import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class TsneGraph  extends AbstractScatterVisualization {
}
